import { OrderFields } from "../constants";
import { TOrderFormData } from "../models/orderForm";
import { TOffer } from "../types";

const isNullishOrEqualTo = (value: any | undefined | null, compareTo: any): boolean =>
  typeof value === "undefined" || value === null || value === compareTo;

const getIsOfferCurrent = (offer: TOffer, order: TOrderFormData): boolean => {
  if (!offer.params) {
    return true;
  }

  const {
    countryFrom,
    countryTo,
    packageSizeTitle,
    deliveryMethod,
    promoCode,
    senderZipCode,
    receiverZipCode,
    affiliateId,
  } = offer.params;

  return (
    isNullishOrEqualTo(countryFrom, order[OrderFields.STARTING_COUNTRY]) &&
    isNullishOrEqualTo(countryTo, order[OrderFields.DESTINATION_COUNTRY]) &&
    isNullishOrEqualTo(packageSizeTitle, order[OrderFields.PACKAGE_SIZE]) &&
    isNullishOrEqualTo(deliveryMethod, order[OrderFields.DELIVERY_METHOD]) &&
    isNullishOrEqualTo(promoCode, order[OrderFields.PROMO_CODE]) &&
    isNullishOrEqualTo(senderZipCode, order[OrderFields.SENDER_ZIP_CODE]) &&
    isNullishOrEqualTo(receiverZipCode, order[OrderFields.RECEIVER_ZIP_CODE]) &&
    isNullishOrEqualTo(affiliateId, order[OrderFields.AFFILIATE_ID])
  );
};
export default getIsOfferCurrent;
